import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { AzureSsoService } from './azure-sso.service';

angular.module('app-lite.azure-sso', [])
  .service('azureSsoApi', downgradeInjectable(AzureSsoService));
